import { useApiRequestHelper } from '@/composables/useApiRequestHelper.js'
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useAuthStore = defineStore(
  'auth',
  () => {
    const { $apiAuthenticatedRequest } = useApiRequestHelper()

    const maintainableEntity = ref({})
    const hasReducedAccess = ref(false)
    const user = ref({})
    const isAuthenticated = ref(false)
    const isLoggingOut = ref(false)

    const updateUser = async (
      userId,
      userLanguage,
      userLocale,
      maintainableEntityId,
      reducedAccess,
    ) => {
      return $apiAuthenticatedRequest.index('users').then(async ({ data }) => {
        const userDetails = data.find((user) => user.id === userId)

        if (userDetails) {
          user.value = {
            ...userDetails,
            language: userLanguage ?? 'en',
            locale: userLocale ?? 'en-GB',
          }
          hasReducedAccess.value = reducedAccess

          await $apiAuthenticatedRequest
            .get(
              'maintainable-entities',
              $apiAuthenticatedRequest.configs.get.setId(maintainableEntityId),
            )
            .then(({ data }) => {
              maintainableEntity.value = data
            })
        } else {
          throw new Error('User not found')
        }
      })
    }

    const logout = async () => {
      reset(true)
    }

    const reset = (loggingOut = false) => {
      maintainableEntity.value = {}
      hasReducedAccess.value = false
      user.value = {}
      isAuthenticated.value = false
      isLoggingOut.value = loggingOut
    }

    return {
      maintainableEntity,
      hasReducedAccess,
      user,
      isAuthenticated,
      isLoggingOut,
      updateUser,
      logout,
      reset,
    }
  },
  {
    persist: true,
  },
)
